<template>  
    <div id="content">      
      <div class="grid grid-cols-2 justify-items-center" id="post-list">
        <div class="post lg:w-2/5 lg:col-span-1 col-span-2 w-full mb-10" v-for="post in posts" v-bind:key="post">
          <p>{{post}}</p>
        </div>
      </div>
    </div>
</template>

<script>
  let phrase = "Accomplished Software Engineer with over 9 years of experience in developing scalable web applications and enhancing business operations through innovative software solutions. Proven expertise in .NET frameworks, JavaScript, SQL Server, Power BI, and Azure Cloud Services. Strong problem-solving skills and ability to work in dynamic, fast-paced environments.";
  
  export default {
    name: "HomePage",    
    data() {
      return {          
          posts: [
            phrase,
        ]
      }      
    }
  }
</script>